<app-svg-icon
    [icon]="icon"
    (click)="toggle(); $event.stop()"
    style="user-select: none; cursor: pointer"
/>
